//
//
//
//
//
//
//

import AppHeader from './components/AppHeader';


// todo: 视实际增减
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/radar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';

export default {
  name: 'ReportApp',
  components: { AppHeader },
  created() {
    if (this.$store.getters.ifLogin 
      && !Object.keys(this.$store.state.user.userInfo).length) {
        this.$store.dispatch('USER_GET_INFO');
      }
    if (this.$store.getters.ifLogin) {
      this.$store.dispatch('USER_GET_SCHOOL_CONFIG');
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/ReportApp/App.vue